import { Pipe, PipeTransform } from '@angular/core';

export interface ReportStatusDisplay {
  text: string;
  icon: string;
  spin?: boolean;
  color?: string;
}

@Pipe({
  name: 'reportStatus',
})
export class ReportStatusPipe implements PipeTransform {
  transform(value: number): ReportStatusDisplay {
    switch (value) {
      case 0:
        return { text: 'Done', icon: 'check-circle', color: 'green' };
      case 1:
        return {
          text: 'InProgress',
          icon: 'loading',
          spin: true,
          color: 'blue',
        };
      case 2:
        return { text: 'Failed', icon: 'close-circle', color: 'red' };
      default:
        return { text: 'Unknown', icon: 'question-circle', color: 'gray' };
    }
  }
}
